const binding = { modules: {}, dataActions: {} };

    (binding.modules['mfrm-footer-email-subscription'] = {
        c: () => require('partner/modules/mfrm-footer-email-subscription/mfrm-footer-email-subscription.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mfrm-footer-email-subscription',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mfrm-footer-email-subscription'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mfrm-footer-email-subscription|mfrm-footer-email-subscription'] = {
                c: () => require('partner/modules/mfrm-footer-email-subscription/mfrm-footer-email-subscription.view.tsx'),
                cn: '__local__-__local__-mfrm-footer-email-subscription'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };